import React from 'react';

import { IIconRotatableProps } from 'assets/icons/IconProps';

export const VerticalDotsIcon = ({
  width = 32,
  height = 32,
  stroke = '#52575C',
  strokeWidth = 2,
  rotate = 0,
}: IIconRotatableProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 32 32"
    style={{ transform: `rotate(${rotate}deg)`, cursor: 'pointer' }}
  >
    <rect width="32" height="32" rx="4" />
    <path
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      d="M16 17c.552 0 1-.448 1-1s-.448-1-1-1-1 .448-1 1 .448 1 1 1zM16 10c.552 0 1-.448 1-1s-.448-1-1-1-1 .448-1 1 .448 1 1 1zM16 24c.552 0 1-.448 1-1s-.448-1-1-1-1 .448-1 1 .448 1 1 1z"
    />
  </svg>
);
